import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, IceCream2 } from "lucide-react";
import { CONTACT } from "@/assets";

export default function Footer() {
  return (
    <footer className="bg-sc-blue py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-2.5">
            <span className="grid place-items-center w-10 h-10 rounded-full bg-sc-espresso text-sc-cream">
              <IceCream2 size={20} strokeWidth={1.6} />
            </span>
            <span className="leading-none">
              <span className="block font-serif-display text-xl text-sc-espresso">Santa Chiara</span>
              <span className="block eyebrow text-[0.6rem] mt-0.5">Gelato Cart · NYC</span>
            </span>
          </div>

          <div className="flex flex-wrap items-center gap-6 text-sm text-sc-espresso/80">
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-sc-espresso">
              <Mail size={16} /> {CONTACT.email}
            </a>
            <a href={`tel:${CONTACT.phone.replace(/[^0-9+]/g, "")}`} className="flex items-center gap-2 hover:text-sc-espresso">
              <Phone size={16} /> {CONTACT.phone}
            </a>
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-sc-espresso">
              <Instagram size={16} /> {CONTACT.instagramHandle}
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-sc-espresso/15 flex flex-col sm:flex-row justify-between gap-3 text-xs text-sc-espresso/60">
          <p>© {new Date().getFullYear()} Santa Chiara Gelato. Authentic Italian gelato in New York.</p>
          <Link to="/admin/login" className="hover:text-sc-espresso" data-testid="footer-admin-link">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
